import { render, staticRenderFns } from "./generalSettings.vue?vue&type=template&id=50c7d792&scoped=true"
import script from "./generalSettings.vue?vue&type=script&lang=js"
export * from "./generalSettings.vue?vue&type=script&lang=js"
import style0 from "./generalSettings.vue?vue&type=style&index=0&id=50c7d792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c7d792",
  null
  
)

export default component.exports